<script>
    import { navigate }         from "svelte-routing"
    import _                    from 'lodash'
    import * as api             from '../../shared/api.js'
    import { company, domains } from '../../shared/stores.js'
    import DomainDropdown       from '../../shared/DomainDropdown.svelte'
    import SectionTitle         from '../../shared/SectionTitle.svelte'
    import AppLoader            from '../../shared/Loader.svelte'
    import LaneTransition       from "./LaneTransition.svelte"    
    import InquiryCard          from './InquiryCard.svelte'
    import CardLanes            from './CardLanes.svelte'
    import CardLane             from './CardLane.svelte'
    import Identify             from './Identify.svelte'
    import Execute              from './Execute.svelte'
    import EnableDownload       from './EnableDownload.svelte'
    import Deny                 from './Deny.svelte'

    // let active  = null
    let inquiry     = null
    let buffer      = []
    let transitions = []
    let domain      = null
    let loading     = false
    let error       = false
    let action      = null
    let loadingSettings = true

    let modalActive = false
    let target      = null
    let onConfirm   = null

    export let _inquiry = false
    export let _domain  = false
    export let _company = false

    if(_domain) {
        domain = $domains.find(it => it.domain === _domain)
    }

    function idOf(i) {
        return i.protocol
    }

    function onDomainSelected(selected) {
        domain = selected ? selected.value : null
        if(domain) {
            navigate(`/empresa/${$company.id}/pedidos/${domain.domain}`)
        } else {
            navigate(`/empresa/${$company.id}/pedidos`)
        }
    }

    function titleOf(item) {
        return `[${item.protocol.substring(0, 5)}] ${scopeOf(item)}`
    }

    function scopeOf(item) {
        switch(item.scope) {
            case 'SAR': return 'Pedido de Acesso'
            case 'DDR': return 'Pedido de Remoção'
            default   : return 'Pedido desconhecido'
        }
    }

    function sort(it) {
        return it.created
    }

    function onUpdate(item) {
        const filtered = buffer.filter(i => i.protocol !== item.protocol)
        buffer = _.sortBy([...filtered, item], sort).reverse()
    }

    function loadTransitions(domain) {
        if(!domain)
            return 
        
        api
            .get(`/inquiries/domain/${domain.id}/settings`)
            .then(api.toJsonIf200)
            .then(json => {
                transitions = json
                loadingSettings = false
            })
            .catch(err => {
                console.log(`Error loading transition settings for domain ${domain.domain}`, err)
            })
    }

    function loadBuffer(domain) {
        if(!domain) {
            buffer = []
            return 
        } 

        loading = true
        return api.get(`/inquiries/domain/${domain.id}`)
            .then(api.toJsonIf200)
            .then(json => {
                buffer = json.map(i => {
                    return { 
                        status  : i.status, 
                        inquiry : i
                    }
                })
                loading = false
                error   = false
            })
            .catch(err => {
                loading = false
                error   = err
            })        
    }
    
    function reload() {
        active = null
        if(_inquiry) {
            navigate(`/empresa/${$company.id}/pedidos/${domain.domain}`)
        } else {
            loadBuffer(domain)
        }
    }

    function items(array, keys) {
        const result = array.filter(el => {
            return keys.find(i => i === el.status) !== undefined
        })
        return _.orderBy(result, ['inquiry.id'], ['desc'])
    }

    function resolve(item) {
        return item.inquiry.protocol
    }

    function allowTransition(ctx) {
        if(ctx.from !== ctx.to) {
            switch(ctx.from) {
                case "CREATED"       : return ctx.to === "IDENTIFIED" || ctx.to === 'DENIED'
                case "IDENTIFIED"    : return ctx.to === "EXECUTING"
                case "REPORT SUCCESS": return ctx.to === "REPORT AVAILABLE"
            }
        }
        return false
    }
    
    function finishTransition(copy) {
        if(allowTransition(copy)) {
            target = copy.to
            new Promise( (resolve, reject) => {
                inquiry     = copy.item.inquiry
                onConfirm   = resolve
                modalActive = true
            }).then(allow => {
                target      = null
                inquiry     = null
                modalActive = false
                if(allow) {
                    updateLanes(copy)
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }

    function updateLanes(ctx) {
        const replacement = buffer.filter(item => item.inquiry.protocol !== ctx.item.inquiry.protocol)
        const updated     = _.assign({}, ctx.item.inquiry, { status: ctx.to })
        replacement.push({ status : ctx.to, inquiry: updated })
        buffer = replacement
    }

    $: loadBuffer(domain)
    $: loadTransitions(domain)
    $: created    = items(buffer, ['CREATED'])
    $: denied     = items(buffer, ['DENIED'])
    $: identified = items(buffer, ['IDENTIFIED'])
    $: onhold     = items(buffer, ['ON HOLD'])
    $: executing  = items(buffer, ['EXECUTING', 'GENERATING REPORT'])
    $: ready      = items(buffer, ['REPORT SUCCESS', 'REPORT ERROR'])
    $: done       = items(buffer, ['REPORT AVAILABLE'])
</script>
<style>
    .grid {
        margin: 3em 0;
        display: grid;
        grid-template-areas: "created accepted denied executing onhold ready done";
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-rows   : 1fr;
        grid-gap: 1em;
    }

    .grid .created   { grid-area: created   ; /* background-color: red    ; */ }
    .grid .accepted  { grid-area: accepted  ; /* background-color: green  ; */ }
    .grid .denied    { grid-area: denied    ; /* background-color: orange ; */ }
    .grid .executing { grid-area: executing ; /* background-color: yellow ; */ }
    .grid .onhold    { grid-area: onhold    ; /* background-color: blue   ; */ }
    .grid .ready     { grid-area: ready     ; /* background-color: orange ; */ }
    .grid .done      { grid-area: done      ; /* background-color: orange ; */ }

    .grid .created   .header { background-color: var(--color-blue)   ; }
    .grid .accepted  .header { background-color: var(--color-violet) ; }
    .grid .denied    .header { background-color: var(--color-red)    ; }
    .grid .executing .header { background-color: var(--color-olive)  ; }
    .grid .onhold    .header { background-color: var(--color-orange) ; }
    .grid .ready     .header { background-color: var(--color-green)  ; }
    .grid .done      .header { background-color: var(--color-black)  ; }

    .grid .header {
        font-size     : 13pt;
        font-weight   : 700;
        color         : #fff;
        border-radius : 1em;
        padding       : .5em;
        text-align    : center;
        margin        : 2em 0; 
        _border: 1px solid red;
    }

    .grid .col {
        position: relative;
        _border: 1px solid yellow;
    }
</style>
<svelte:head>
	<title>Dogma / {$company.name} / Pedidos</title>
</svelte:head>
{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Pedidos dos Titulares
    </SectionTitle>

    <DomainDropdown {domain} {onDomainSelected} />

    {#if !domain}
        <div class="ui big message">
            Selecione um domínio
        </div>
    {:else}
        <!-- <button on:click={ reload } class="ui blue right labeled icon button">
            <i class="redo icon"></i>
            Recarregar
        </button> -->
        <CardLanes>
            <div class="grid">
                <div class="created col ui blue">
                    <LaneTransition {domain} {transitions} loading={loadingSettings} status="CREATED"></LaneTransition>
                    <div class="header">Novos</div>
                    <CardLane   id       = "CREATED" 
                                items    = {created}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
                <div class="accepted col">
                    <LaneTransition {domain} {transitions} loading={loadingSettings} status="IDENTIFIED"></LaneTransition>
                    <div class="header">Identificados</div>
                    <CardLane   id       = "IDENTIFIED" 
                                items    = {identified}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition}
                                {resolve}></CardLane>
                </div>
                <div class="denied col">
                    <div class="header">Negados</div>
                    <CardLane   id       = "DENIED" 
                                items    = {denied}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
                <div class="executing col">
                    <div class="header">Executando</div>
                    <CardLane   id       = "EXECUTING" 
                                items    = {executing}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
                <div class="onhold col">
                    <div class="header">Aguardando</div>
                    <CardLane   id       = "ON HOLD" 
                                items    = {onhold}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
                <div class="ready col">
                    <LaneTransition {domain} {transitions} loading={loadingSettings} status="REPORT SUCCESS"></LaneTransition>
                    <div class="header">Prontos</div>
                    <CardLane   id       = "REPORT SUCCESS" 
                                items    = {ready}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
                <div class="done col">
                    <div class="header">Disponíveis</div>
                    <CardLane   id       = "REPORT AVAILABLE" 
                                items    = {done}
                                card     = {InquiryCard}
                                {allowTransition}
                                {finishTransition} 
                                {resolve}></CardLane>
                </div>
            </div>
        </CardLanes>
        <Identify       active = { modalActive && target == 'IDENTIFIED'       } item = { inquiry } onAction = { onConfirm } />
        <Deny           active = { modalActive && target == 'DENIED'           } item = { inquiry } onAction = { onConfirm } />
        <Execute        active = { modalActive && target == 'EXECUTING'        } item = { inquiry } onAction = { onConfirm } />
        <EnableDownload active = { modalActive && target == 'REPORT AVAILABLE' } item = { inquiry } onAction = { onConfirm } />
    {/if}

{/if}

